import { Tooltip } from "@mui/material";
import styles from "./DrawShapeAgenda.module.scss";

export interface DrawShapeLegend {
  shapeId: string;
  lineIndex: number;
  lineColor: string;
  lineName: string;
  description?: string;
}

export interface DrawShapeAgendaProps {
  legend: DrawShapeLegend;
  onClose?: (shapeId: string) => void;
}

export function DrawShapeAgenda(props: DrawShapeAgendaProps) {
  const { legend, onClose } = props;

  const handleDelete = () => {
    onClose?.(legend.shapeId);
  };

  return (
    <div className={styles.drawShapeAgenda} data-shape-id={legend.shapeId}>
      <span
        className={styles.linePreview}
        style={{ backgroundColor: legend.lineColor }}
      ></span>
      <div className={styles.lineInfo}>
        <Tooltip title={`${legend.lineName}`}>
          <div className={styles.lineName}>{legend.lineName}</div>
        </Tooltip>
        {legend.description && (
          <div className={styles.description}>{legend.description}</div>
        )}
      </div>
      <div className={styles.actions}>
        <div
          role="button"
          tabIndex={0}
          className={`material-icons ${styles.icon}`}
          onClick={handleDelete}
        >
          cancel
        </div>
      </div>
    </div>
  );
}
